/*---------------------------------------------------------------------------*/
/*                         Shopify Country Detection                         */ 
/*---------------------------------------------------------------------------*/

const euCountry = ["BG","HR","CY","CZ","DK","EE","FI","GR","HU","IS","LV","LI","LT","LU","MT","NO","PL","RO","SI","SE"];
const euMarkets = ["ES","FR","AT","DE","IT","PT","IE","BE","NL"];
const ukMarkets = ["GB","JE","IM","GG"];
const rowMarket = ["AL","DZ","AD","AI","AG","AR","AM","AW","AU","AZ","BS","BH","BD","BB","BZ","BJ","BM","BT","BO","BA","BW","BR","VG","BN","KH","CA","CV","KY","CL","CN","CO","KM","CK","CR","CW","DJ","DM","DO","EC","EG","SV","ET","FK","FO","FJ","GF","PF","GE","GI","GL","GD","GP","GT","GN","GW","GY","HT","HN","HK","IN","ID","IL","JM","JP","JO","KZ","KE","KI","KW","KG","LA","LB","LS","MO","MG","MW","MY","MV","MQ","MR","MU","MX","MD","MC","MN","ME","MS","MA","MZ","NA","NR","NP","NC","NZ","NI","NG","NU","MK","OM","PK","PA","PG","PY","PE","PH","QA","RE","WS","SM","ST","SA","SN","RS","SC","SG","SB","ZA","KR","LK","BL","KN","LC","MF","SD","SR","CH","TW","TJ","TZ","TH","TL","TO","TT","TN","TR","TM","TC","TV","AE","US","UY","UZ","VU","VA","VE","VN","WF","ZM","ZW"];

let gotoStore;
let countryCode;
let countryISO;
let lan;
let lanSelectBox;
let autoSelectedLan;



jQuery(document).ready(function() {
    let detectCountry;




    if(Shopify.country == 'GB'){
      Cookies.remove('bamPopup');
    }
    jQuery.get('/browsing_context_suggestions.json', (d) => { 
      detectCountry = d.detected_values.country.name;
      countryISO = d.detected_values.country.handle;


     
        

      if(rowMarket.includes(countryISO) == false){
          jQuery('#bam-button-save').attr('data-redirectcon','true');
      }else{
          jQuery('#bam-button-save').attr('data-redirectcon','false');
      }


      let flagScreen = 'background-image:url(https://cdn.shopify.com/static/images/flags/'+countryISO.toLowerCase()+'.svg);';
      jQuery('#flag').attr('style',flagScreen);

      jQuery("#loc__").val(countryISO);
      jQuery("#countryloc__").val(countryISO);

      if(countryISO == 'BE'){
        lan = {lang:"nl,fr,en", langName:"Nederlands,Français,English" };
        jQuery('.language_wraper').show()
      }
      else if(countryISO == 'PT'){
        lan = {lang:"pt-pt,en",langName:"português (Portugal),English"};
        jQuery('.language_wraper').hide();
      }
      else if(countryISO == 'IT'){
        lan = {lang: "it,en", langName:"Italiano ,English"};
        jQuery('.language_wraper_country').hide();
      }
      else if(countryISO == 'ES'){
        lan = {lang: "es,en", langName:"Español ,English"};
        jQuery('.language_wraper_country').hide();
      }
      else if(countryISO == 'AT'){
        lan = {lang: "de", langName:"Deutsch" };
        jQuery('.language_wraper_country').hide();
      }
      else if(countryISO == 'FR'){
        lan = {lang: "fr", langName:"Français"};
        jQuery('.language_wraper_country').hide();
      }
      else if(countryISO == 'DE'){
        lan = {lang: "de", langName:"Deutsch"};
        jQuery('.language_wraper_country').hide();
      }
      else if(countryISO == 'NL'){
        lan = {lang: "nl,en", langName: "Nederlands,English"};
        jQuery('.language_wraper_country').hide();
      }
      else if(countryISO == "GB" || countryISO == "JE" || countryISO == "IM" || countryISO == "GG"){
        lan = {lang: "en", langName:"English"};
        jQuery('.language_wraper_country').hide();
      }
      else{
         lan = {lang: "en,de,es,fr,it,nl,pt-pt" , langName: "English,Deutsch,Español,Français,Italiano,Nederlands,português (Portugal)" };
        jQuery('.language_wraper_country').show();
      }

      let lanMaster = lan.lang.split(",");
      let lanMasterCity = lan.langName.split(",");
      let lanMasterLength = lanMaster.length;
      let pathname = window.location.pathname;
      let langCode= pathname.split("/");
      let langCodeClean = langCode[1].split("-");

      if(langCode[1] == 'fr' || 
         langCode[1] == 'nl' || 
         langCode[1] == 'de' || 
         langCode[1] == 'pt' || 
         langCode[1] == 'it' || 
         langCode[1] == 'es' ||
         langCode[1] == 'fr-fr' || 
         langCode[1] == 'nl-nl' || 
         langCode[1] == 'de-de' || 
         langCode[1] == 'pt-pt' || 
         langCode[1] == 'it-it' || 
         langCode[1] == 'es-es' ){
         jQuery("#loc__lan").val(langCodeClean[0]);  
      }else{
         jQuery("#loc__lan").val(Shopify.locale);
      }
      //jQuery("#loc__lan").val(lanMaster[0]);
      jQuery("#countryloc__lan").val(lanMaster[0]);      
      jQuery('#s').find('option').remove();
      jQuery('#bam__country__language__selector').find('option').remove(); 
      for (let i = 0; i < lanMasterLength; i++) {
           jQuery('#bam__shipping__language__selector').append('<option value="'+lanMaster[i]+'">'+lanMasterCity[i]+'</option>');
           jQuery('#bam__country__language__selector').append('<option value="'+lanMaster[i]+'">'+lanMasterCity[i]+'</option>');
      }

      jQuery('#current__country').html(detectCountry);
      jQuery('#suggestion__country').html(detectCountry);
      jQuery('#ship__to').html(detectCountry);
      jQuery('#ship__to_welcome').html(detectCountry);
      jQuery("#bam__country__selector option[value='"+countryISO+"']").prop('selected',true);
      gotoStore = jQuery("#bam__country__selector").find(':selected').data('redirecturl');
      countryCode = jQuery("#bam__country__selector").val();
        if(euMarkets.includes(countryISO) != true){
            if(Cookies.get('topBanner') != 'false'){
              jQuery("#country___suggestion").css('display','flex');
              jQuery("#country___suggestion").attr('data-position','open');
              jQuery("#country___suggestion").addClass('op_color'); 
            } 
            
          }
        if((euMarkets.includes(countryISO) == true) && Shopify.country != countryISO ){
            if(Cookies.get('bamPopup') != 'false'){
              jQuery('#bam__shipping__modal').css({'display':'flex','opacity':'1'});
            } 
            
          }
        else{
            jQuery('#bam__modal__for_EU').css({'display':'flex','opacity':'1'});
          }
    });
});

// Open Modal Info //
jQuery(document).on('touchstart click','#bam_country_changer', function (event){
    event.preventDefault();
    jQuery('#bam__modal').css({'display':'flex','opacity':'1'});
    jQuery("#country___suggestion").attr('data-position','close');
    jQuery("#country___suggestion").removeClass('op_color'); 
});  

// Close Modal Info //
jQuery(document).on('touchstart click','.bam-close', function (event){
    event.preventDefault(); 
    jQuery('#bam__modal').css({'display':'none','opacity':'0'});
});

// Close Shipping Modal Info //
jQuery(document).on('touchstart click','.bam-close_shipping', function (event){
    event.preventDefault(); 
    Cookies.set('bamPopup', 'false', { expires: 14 });
    jQuery('#bam__shipping__modal').css({'display':'none','opacity':'0'});
});

// Close Modal Info When click Outside //
/*jQuery(document).click(function(e){
  let modal_target = jQuery(".bam-country-selector");
  let modal_target_flag = jQuery("#bam_country_changer");
  let modal_target_country = jQuery('#country__select_shipping');
  if (!modal_target.is(e.target) && modal_target.has(e.target).length === 0 &&
      !modal_target_flag.is(e.target) && modal_target_flag.has(e.target).length === 0 &&
      !modal_target_country.is(e.target) && modal_target_country.has(e.target).length === 0){
     jQuery('#bam__modal').css({'display':'none','opacity':'0'});
    }
});*/


// Close Top Suggestion Bar //
jQuery(document).on('touchstart click','.cw-close', function (event){
    event.preventDefault();
    Cookies.set('topBanner', 'false', { expires: 1 })
    jQuery('.country-warning-wrapper').css({'display':'none'});
});

// Modal Info Button Cancel //
jQuery(document).on('touchstart click','#bam-button-cancel', function (event){
    event.preventDefault(); 
    jQuery('#bam__modal').css({'display':'none','opacity':'0'});
});

// Selectbox Change //
jQuery( "#bam__country__selector" ).change(function() {
    gotoStore = jQuery(this).find(':selected').data('redirecturl');
    countryCode = jQuery(this).val();
});
 
// Modal Info Button Save //
jQuery(document).on('touchstart click','#bam-button-save', function (event){
    event.preventDefault();
    let get_red = jQuery(this).attr('data-redirectcon');
    if(get_red != 'true'){
      jQuery('#country_loc').submit();
    }else{
      if(euCountry.includes(jQuery('#bam__country__selector').val()) == true || euMarkets.includes(jQuery('#bam__country__selector').val()) == true){
        let get_lang_opt = jQuery('#bam__country__language__selector').val();
        let get_count_opt = jQuery('#bam__country__selector').val();

        if(get_lang_opt == 'en'){
          get_lang_opt = "";
        }
     
        if(get_count_opt == 'BE'){
          let red_lan = get_lang_opt;
          location.replace('https://www.bambinomio.eu/'+red_lan);
          return false;  
       }
       else if(get_count_opt == 'PT'){
         let red_lan = 'pt-pt';
         location.replace('https://www.bambinomio.eu/'+red_lan);
         return false;  
       }
       else if(get_count_opt == 'IT'){
         let red_lan = 'it-it';
         location.replace('https://www.bambinomio.eu/'+red_lan);
         return false;  
       }
       else if(get_count_opt == 'ES'){
         let red_lan = 'es-es';
         location.replace('https://www.bambinomio.eu/'+red_lan);
         return false;  
       }
       else if(get_count_opt == 'AT'){
         let red_lan = 'de';
         location.replace('https://www.bambinomio.eu/'+red_lan);
         return false;  
       }
       else if(get_count_opt == 'FR'){
         let red_lan = 'fr-fr';
         location.replace('https://www.bambinomio.eu/'+red_lan);
         return false;  
       }
       else if(get_count_opt == 'DE'){
         let red_lan = 'de-de';
         location.replace('https://www.bambinomio.eu/'+red_lan);
         return false;  
       }
       else if(get_count_opt == 'NL'){
         let red_lan = 'nl-nl';
         location.replace('https://www.bambinomio.eu/'+red_lan);
         return false;  
       }
       else{
         let red_lan = get_lang_opt;
         location.replace('https://www.bambinomio.eu/'+red_lan);
         return false;  
       } 
      }
      if(ukMarkets.includes(jQuery('#bam__country__selector').val()) == true){
        location.replace('https://bambinomio.co.uk'); 
        return false;  
      }

       if(rowMarket.includes(jQuery('#bam__country__selector').val()) == true){
        location.replace('https://bambinomio.com'); 
        return false;  
      }
    }
    
});


// Close Top Suggestion Bar //
jQuery(document).on('click','.redir-message', function (event){
    event.preventDefault(); 

    if(ukMarkets.includes(countryISO) == true){
    location.replace('https://bambinomio.co.uk'); 
    return false;  
     }
    if(euCountry.includes(countryISO) == true || euMarkets.includes(countryISO) == true ){

      if(countryISO == 'BE'){
         let red_lan = 'nl';
         location.replace('https://www.bambinomio.eu/'+red_lan);
         return false;  
      }
      else if(countryISO == 'PT'){
        let red_lan = 'pt-pt';
        location.replace('https://www.bambinomio.eu/'+red_lan);
        return false;  
      }
      else if(countryISO == 'IT'){
        let red_lan = 'it-it';
        location.replace('https://www.bambinomio.eu/'+red_lan);
        return false;  
      }
      else if(countryISO == 'ES'){
        let red_lan = 'es-es';
        location.replace('https://www.bambinomio.eu/'+red_lan);
        return false;  
      }
      else if(countryISO == 'AT'){
        let red_lan = 'de';
        location.replace('https://www.bambinomio.eu/'+red_lan);
        return false;  
      }
      else if(countryISO == 'FR'){
        let red_lan = 'fr-fr';
        location.replace('https://www.bambinomio.eu/'+red_lan);
        return false;  
      }
      else if(countryISO == 'DE'){
        let red_lan = 'de-de';
        location.replace('https://www.bambinomio.eu/'+red_lan);
        return false;  
      }
      else if(countryISO == 'NL'){
        let red_lan = 'nl-nl';
        location.replace('https://www.bambinomio.eu/'+red_lan);
        return false;  
      }
      else{
        location.replace('https://www.bambinomio.eu');
        return false;  
      } 
   
    }
});



// Change your shipping country //
jQuery(document).on('touchstart click','#country__select_shipping', function (event){
    event.preventDefault(); 
    jQuery('#bam__shipping__modal').css({'display':'none','opacity':'0'});
    jQuery('.main-switcher-wrapper').css({'display':'flex','opacity':'1'});
});



// Close shipping country //
jQuery(document).on('touchstart click','#bam-button-continue', function (event){
    event.preventDefault(); 
    Cookies.set('bamPopup', 'false', { expires: 14 });
    jQuery('#shipping_loc').submit();

});


// Country Selector Changed //
jQuery(document).on('change','#bam__country__selector', function (event){
    event.preventDefault(); 
    let shipping_selected_country = jQuery(this).val(); 
    let getArrayLanguages = jQuery(this).find(':selected').attr('data-languages').split(',');
    let arrayLength = getArrayLanguages.length;
    let isRedirect = jQuery('option:selected', this).attr('data-redirect');

    jQuery('#bam-button-save').attr('data-redirectcon',isRedirect);

    if(arrayLength == 1)
    {
      jQuery(".language_wraper_country").hide();
      jQuery("#countryloc__lan").val(jQuery(this).find(':selected').attr('data-languages'));
    }
    else{
      jQuery(".language_wraper_country").show();
      jQuery("#countryloc__lan").val(getArrayLanguages[0]);
    }
  
    jQuery('#countryloc__').val(shipping_selected_country);



    if(shipping_selected_country == 'BE'){
        lanSelectBox = {lang:"nl,fr,en", langName:"Nederlands,Français,English" };
      }
      else if(shipping_selected_country == 'PT'){
        lanSelectBox = {lang:"pt-pt,en",langName:"português (Portugal),English"};
      }
      else if(shipping_selected_country == 'IT'){
        lanSelectBox = {lang: "it,en", langName:"Italiano ,English"};
      }
      else if(shipping_selected_country == 'ES'){
        lanSelectBox = {lang: "es,en", langName:"Español ,English"};
      }
      else if(shipping_selected_country == 'AT'){
        lanSelectBox = {lang: "de", langName:"Deutsch" };
      }
      else if(shipping_selected_country == 'FR'){
        lanSelectBox = {lang: "fr", langName:"Français"};
      }
      else if(shipping_selected_country == 'DE'){
        lanSelectBox = {lang: "de", langName:"Deutsch"};
      }
      else if(shipping_selected_country == 'NL'){
        lanSelectBox = {lang: "nl,en", langName: "Nederlands,English"};
      }
      else if(shipping_selected_country == "GB" || shipping_selected_country == "JE" || shipping_selected_country == "IM" || shipping_selected_country =="GG"){
        lanSelectBox = {lang: "en", langName: "English"};
        jQuery(".language_wraper_country").hide();
      }
      else{
        lanSelectBox = {lang: "en,de,es,fr,it,nl,pt-pt" , langName: "English,Deutsch,Español,Français,Italiano,Nederlands,português (Portugal)" };
      } 
  
    let getLangugesOption =  lanSelectBox.lang.split(",").length;
    let lang__Code = lanSelectBox.lang.split(",");
    let lang__City = lanSelectBox.langName.split(",");
    jQuery('#countryloc__lan').val(lang__Code[0]);
    jQuery('#bam__country__language__selector').find('option').remove(); 
      for (let i = 0; i < getLangugesOption; i++) {
           jQuery('#bam__country__language__selector').append('<option value="'+lang__Code[i]+'">'+lang__City[i]+'</option>');
      }
    let lowercased = shipping_selected_country.toLowerCase();
    if(euMarkets.includes(shipping_selected_country) == true){
        jQuery("#bam__country__language__selector").find("option").eq(0).prop('selected',true);
        jQuery('.language_wraper').css({'display':'block','opacity':'1'});
    }
});

// Shipping Language Selector Changed //
jQuery(document).on('change','#bam__shipping__language__selector', function (event){
    event.preventDefault(); 
    let setLanguageShipping = jQuery(this).val();
    jQuery("#loc__lan").val(setLanguageShipping);

});


// Country Language Selector Changed //
jQuery(document).on('change','#bam__country__language__selector', function (event){
    event.preventDefault(); 
    let setLanguageCountry = jQuery(this).val();
    jQuery("#countryloc__lan").val(setLanguageCountry);

});


function sortSelectOptions(selectElement) {
	var options = $(selectElement + " option");

	options.sort(function(a,b) {
		if (a.text.toUpperCase() > b.text.toUpperCase()) return 1;
		else if (a.text.toUpperCase() < b.text.toUpperCase()) return -1;
		else return 0;
	});

	$(selectElement).empty().append( options );
}


sortSelectOptions('#bam__country__selector');










